// extracted by mini-css-extract-plugin
module.exports = {"talkFlowEditor":"lexical_editor_talkflow_talkFlowEditor__ca_VU"};